import listSaga from './listSaga'
import oneCitySaga from './oneCitySaga'

const citiesSagas = [listSaga(), oneCitySaga()]

export default citiesSagas
